import { Link } from 'react-router-dom';
import { ArrowRight, ShieldCheck, Sparkles, Ticket, BarChart3 } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { Card } from '@/components/ui/Card';

const highlights = [
  {
    icon: ShieldCheck,
    title: 'Security & AutoMod',
    description: 'Twelve independent protections, anti-nuke, and heat-based threat scoring.',
    accent: 'text-accent-security-400',
  },
  {
    icon: Sparkles,
    title: 'Dem AI',
    description: 'Multi-provider AI assistant with automatic failover and per-guild settings.',
    accent: 'text-accent-ai-400',
  },
  {
    icon: Ticket,
    title: 'Tickets & Community',
    description: 'Support tickets, reaction roles, leveling, and more — configured visually.',
    accent: 'text-accent-tickets-400',
  },
  {
    icon: BarChart3,
    title: 'Analytics',
    description: 'Server activity, moderation trends, and engagement — without a single chat command.',
    accent: 'text-accent-analytics-400',
  },
];

export function HomePage() {
  return (
    <div>
      <section className="max-w-4xl mx-auto px-4 md:px-8 pt-16 md:pt-24 pb-16 text-center">
        <h1 className="text-display text-text-primary max-w-2xl mx-auto">
          A real dashboard for a real Discord bot.
        </h1>
        <p className="text-body text-text-secondary mt-4 max-w-xl mx-auto">
          Dem Web is the in-progress companion dashboard for Dem — configure moderation, AutoMod,
          tickets, and more from the browser instead of chat commands.
        </p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <Link to="/dashboard">
            <Button variant="primary" size="lg">
              Open dashboard
              <ArrowRight size={16} aria-hidden="true" />
            </Button>
          </Link>
          <Link to="/features">
            <Button variant="secondary" size="lg">
              See what's planned
            </Button>
          </Link>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-4 md:px-8 pb-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {highlights.map((item) => (
            <Card key={item.title}>
              <item.icon size={22} className={item.accent} aria-hidden="true" />
              <h3 className="text-h3 text-text-primary mt-3">{item.title}</h3>
              <p className="text-small text-text-secondary mt-1">{item.description}</p>
            </Card>
          ))}
        </div>
      </section>
    </div>
  );
}
